import { ParsedGoogleDocType } from './types'

export function parseGoogleDoc(gdoc: Document) {
  const currentExtraContent: string[] = []
  const stuff = Array.from(gdoc.body.children).reduce<ParsedGoogleDocType>(
    ({ extraContent, tableContent, objectContent, originalDoc }, node) => {
      if (node.tagName === 'TABLE') {
        if (currentExtraContent.length) {
          extraContent.push(`<p>${currentExtraContent.join('')}</p>`)
        }
        currentExtraContent.length = 0
        const { contentTypeKey, key, data } = parseDocTable(
          node as HTMLTableElement,
        )
        if (contentTypeKey === 'tableContent') {
          if (!(key in tableContent)) {
            tableContent[key] = []
          }
          tableContent[key].push(data)
        } else if (contentTypeKey === 'objectContent') {
          objectContent[key] = data
        }
      } else {
        currentExtraContent.push(node.outerHTML)
      }
      return {
        extraContent,
        tableContent,
        objectContent,
        originalDoc,
      }
    },
    {
      extraContent: [],
      tableContent: {},
      objectContent: {},
      originalDoc: gdoc,
    },
  )
  if (currentExtraContent.length) {
    stuff.extraContent.push(`<p>${currentExtraContent.join('')}</p>`)
  }
  return stuff
}

type TableContentResult = {
  contentTypeKey: 'tableContent'
  key: string
  data: Record<string, string>
}

type ObjectContentResult = {
  contentTypeKey: 'objectContent'
  key: string
  data: { headers: string[]; data: Record<string, string>[] }
}

function parseDocTable(
  table: HTMLTableElement,
): TableContentResult | ObjectContentResult {
  const cellLength = table.rows.item(1)?.cells.length
  if (cellLength === 2) {
    return {
      contentTypeKey: 'tableContent',
      ...parseDataTable(table),
    }
  }
  return {
    contentTypeKey: 'objectContent',
    ...parseObjectTable(table),
  }
}

function parseObjectTable(table: HTMLTableElement) {
  const key = (table.rows.item(0)?.textContent ?? 'TABLE').trim()
  const headers = Array.from(table.rows.item(1)?.cells ?? []).map((cell) =>
    cell.textContent!.trim(),
  )
  const data = Array.from(table.rows).reduce<{
    headers: string[]
    data: Record<string, string>[]
  }>(
    (acc, row) => {
      if (row.rowIndex < 2) return acc
      const obj = Array.from(row.cells).reduce<Record<string, string>>(
        (acc, cell) => {
          acc[headers[cell.cellIndex]] = cell.innerHTML.trim()
          return acc
        },
        {},
      )

      return {
        ...acc,
        data: [...acc.data, obj],
      }
    },
    { headers, data: [] },
  )
  return { key, data }
}

function parseDataTable(table: HTMLTableElement) {
  const key = (table.rows.item(0)?.textContent ?? 'TABLE').trim()
  const data = Array.from(table.rows).reduce<Record<string, string>>(
    (acc, row) => {
      if (row.rowIndex === 0) return acc
      const rowKey = row.cells.item(0)?.textContent ?? 'CELL'
      const data = row.cells.item(1)?.innerHTML ?? 'CELLCONTENT'

      return {
        ...acc,
        [rowKey.trim()]: data,
      }
    },
    {},
  )
  return { key, data }
}
